import { initializeAgenda } from 'owa-agenda-events-list';
import { initializeAgenda as initializeAgendaInternalAction } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import { AgendaScenarioId } from '../constants';
import { getSelectedCalendarsFlatList } from 'owa-calendar-module-selected-calendars-user-config';
import { getSelectedDateDateRange } from 'owa-calendar-surface-surface-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { canUseToDoFeatures } from 'owa-todo-utils/lib/utils/moduleAccessUtils';
import { shouldShowDeclinedEvents } from 'owa-show-declined-meetings-user-config';

export const initializeAgendaOrchestrator = orchestrator(
    initializeAgendaInternalAction,
    actionMessage => {
        const selectedCalendars = getSelectedCalendarsFlatList();
        initializeAgenda(
            getSelectedDateDateRange().start,
            selectedCalendars,
            AgendaScenarioId,
            isFeatureEnabled('todo-calendar-surface') && canUseToDoFeatures(),
            shouldShowDeclinedEvents(),
            'CalendarAgenda',
            {
                maxDays: 1,
                showDateRangeFooter: false,
            }
        );
    }
);
